import React, { useState } from 'react'
import { CallRounded, FacebookRounded, Instagram, Mail } from '@mui/icons-material'
import {BackToTop, CustomerSupport, Email, FormField, ImageBuffer, Loader} from '../'
import {Name} from '../'
import { logo } from '../../assets'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../reducers/store'

import './footer.css'

const Footer = () => {
  const dispatch                    = useDispatch<AppDispatch>();
  const [toggleNav, setToggleNav]   = useState<boolean>(false);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setToggleNav(false);

    const element = document.getElementById(id);
    if (element) {
      // const offset = 80; // same as navbar height
      const offset = document.querySelector(".navbar")?.clientHeight || 0;
      const y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <>
      <footer className='footer'>
        <div className="footer__container">
          <div className='footer__container-right'>
            <div className='footer-shop-logo-container'>
              <div className='footer-shop-logo'>
                <div className='footer-shop-logo-wrapper'>
                  <ImageBuffer src={logo} alt='logo' />
                </div>
              </div>
            </div>
            <div className="footer-content">
              <ul className="permalinks">
                <li><a onClick={(e) => handleScroll(e, "hero")} className='menu-link' href="#hero"><span>Home</span></a></li>
                <li><a onClick={(e) => handleScroll(e, "about")} className='menu-link' href="#about"><span>About</span></a></li>
                <li><a onClick={(e) => handleScroll(e, "services")} className='menu-link' href="#services"><span>Services</span></a></li>
                <li><a onClick={(e) => handleScroll(e, "care")} className='menu-link' href="#care"><span>Personalized Care</span></a></li>
                <li><a onClick={(e) => handleScroll(e, "disability")} className='menu-link' href="#disability"><span>Disability Services</span></a></li>
              </ul>
              <p><Name />, LLC is a trusted Texas-based home health agency.</p>
            </div>
            <div className="footer-content">
                <h4>Contact us</h4>
                <div className='footer-contact'>
                    <a href="tel:+14693262931" className='footer-contact-icon'><CallRounded /> +1-469-326-2931</a>
                    <span className='footer-contact-icon'><Mail /> <Email /></span>
                    <ul className="footer__socials">
                        <li><a className='footer__socials_link' href={`https://facebook.com/`} target='_blank' rel="noreferrer"><span><FacebookRounded /></span></a></li>
                        <li><a className='footer__socials_link' href={`https://instagram.com/`} target='_blank' rel="noreferrer"><span><Instagram /></span></a></li>
                    </ul>
                </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className='copyright-detail'>&copy; { new Date().getFullYear() } <Name /> | All rights reserved.</div> 
          
          <a className='developer' target='_blank' href="https://www.sanmexm.com">Developed by Oluwasanmi</a>
        </div>
      </footer>
      <CustomerSupport />
      <BackToTop />
    </>
  )
}

export default Footer